import { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import GlobalModalContext, { Modal } from './GlobalModalContext';

interface Props {
  children?: ReactNode;
}

const GlobalModalProvider: FC<Props> = ({ children }) => {
  const [modal, setModal] = useState<Modal | null>(null);

  const showModal = useCallback((options: Modal) => {
    setModal({
      variant: options.variant ?? 'info',
      header: options.header,
      body: options.body,
      button: options.button ?? 'Close',
      onClose: options.onClose,
      onButtonClick: options.onButtonClick,
    });
  }, []);

  const hideModal = useCallback(() => {
    setModal(null);
  }, []);

  const value = useMemo(
    () => ({
      modal,
      showModal,
      hideModal,
    }),
    [modal, showModal, hideModal],
  );

  return <GlobalModalContext.Provider value={value}>{children}</GlobalModalContext.Provider>;
};

export default GlobalModalProvider;
